import React from 'react';

/**
 * 하단 안전 영역 위에 고정되는 플로팅 버튼 컴포넌트
 * @param {object} props
 * @param {function} props.onClick - 버튼 클릭 핸들러
 * @param {string | React.ReactNode} props.children - 버튼 내부에 표시될 내용 (텍스트 또는 엘리먼트)
 * @param {boolean} [props.disabled=false] - 버튼 비활성화 여부
 * @returns {JSX.Element}
 */
function FloatingButton({ onClick, children, disabled = false }) {
    return (
        // Fixed Wrapper: 화면 하단에 고정 및 안전 영역 처리
        <div style={staticStyles.floatingButtonWrapper}>
            <button
                type="button"
                style={{
                    ...staticStyles.productButton,
                    ...(disabled && staticStyles.productButtonDisabled)
                }}
                onClick={onClick}
                disabled={disabled}
            >
                {/* 2. Label: 버튼 라벨 스타일 적용 */}
                <p style={staticStyles.buttonLabel}>
                    {children}
                </p>
            </button>
        </div>
    );
}

const staticStyles = {
    // 버튼 전체 컨테이너 (Fixed Position)
    floatingButtonWrapper: {
        position: 'fixed',

        bottom: 'env(safe-area-inset-bottom, 34px)',
        left: 0,
        right: 0,
        zIndex: 10, // 헤더와 동일하게 상위 레이어에 표시
        // backgroundColor: '#0D042D', // 배경색과 일치시켜 하단 영역을 덮음

        // 하단 안전 영역 + 여백 처리 (패딩)
        padding: '0 24px',
        paddingTop: '16px',
        paddingBottom: 'calc(env(safe-area-inset-bottom, 34px) + 16px)',

        boxSizing: 'border-box',
    },
    // 실제 버튼 스타일 (Login.jsx의 스타일을 따름)
    productButton: {
        height: '56px',
        width: '100%',
        borderRadius: '6px',
        background: 'linear-gradient(90deg, #8052FF 0%, #0231FB 100%)',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    productButtonDisabled: {
        // background: '#3A3A4A',
        cursor: 'not-allowed',
    },
    buttonLabel: {
        fontFamily: 'Pretendard',
        fontWeight: 700,
        fontSize: '16px',
        color: '#FFFFFF',
        margin: 0,
    },
};

export default FloatingButton;